import { CompanionControls } from "@components/CompanionControls";
import { WorkspaceContent } from "@components/WorkspaceContent";
import { Corkboard } from "@scribenote/brian-design-system";
import { PatientFlowRail } from "@visits/PatientFlowRail";

/**
 * The clinic workspace shell: the espresso desk, full bleed, holding the content
 * window on the left and the persistent Patient Flow rail on the right.
 *
 * There is no header band — the control cluster sits at the top of the rail column
 * instead, spending space that column already used to clear the old band, so the
 * content window runs the full height. That's why the columns have different top
 * offsets: the right starts flush so the controls land where the band's icons were,
 * and `main` carries its own `mt-4` to match its other three gutters. The rail ends
 * up ~13px higher than before (the old band sized to its tallest child at ~77px;
 * the cluster is a flat 64px).
 *
 * The desk is unconditional: paper objects rest on it in every theme, so nothing
 * here reads the theme store any more. Anything sitting directly on it (the rail,
 * the control cluster) writes in `text-ink-inverse`; the window is the corkboard,
 * so everything inside it writes in paper inks.
 */
export const CompanionShell = () => (
  <div className="flex h-screen w-screen gap-6 bg-desk px-4 pb-4 text-ink-inverse">
    {/* `main` only carries the window's position in the desk's flex row; the
        corkboard itself - material, edge light, rounded-sheet, overflow-hidden -
        is the `Corkboard` inside it. Every pane lies on that board: room cards
        and the empty-state note pinned straight to it, the subject folder and
        view panes laid on top of it. */}
    <main className="mt-4 flex min-w-0 flex-1 flex-col">
      <Corkboard className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-sheet text-ink-body">
        {/* No padding or scrolling here: panes run full bleed and own their own
            scroll regions (WEB-3288). */}
        <div className="flex min-h-0 min-w-0 flex-1 flex-col">
          <WorkspaceContent />
        </div>
      </Corkboard>
    </main>

    <div className="flex min-h-0 w-[360px] shrink-0 flex-col">
      <CompanionControls />
      <PatientFlowRail />
    </div>
  </div>
);
